import React from 'react';

// Replace with your actual images in the desired order:
const SQUARE_IMAGES = [
  'https://santaplaya-bucket.s3.amazonaws.com/SPBotana.webp',
  'https://santaplaya-bucket.s3.amazonaws.com/mixta.webp',
  'https://santaplaya-bucket.s3.amazonaws.com/simpler_is_better.webp',
  'https://santaplaya-bucket.s3.amazonaws.com/three_dishes.webp',
];

/**
 * A simple array describing the 4 sections we want to jump to.
 * The 'id' corresponds to the HTML element's id in the packages or add-ons section.
 */
const SECTIONS = [
  { id: 'cocktail-party', label: 'Cocktail Party' },
  { id: 'mariscos-fiesta', label: 'Mariscos Fiesta' },
  { id: 'fish-taco-fiesta', label: 'Fish Taco Fiesta' },
  { id: 'customize-your-event', label: 'Customize' },
];

const QuickNav: React.FC = () => {
  const handleScroll = (targetId: string) => {
    const el = document.getElementById(targetId);
    if (!el) return;

    // Y position of the element relative to the top of the page
    const yPosition = el.getBoundingClientRect().top + window.scrollY;

    // Adjust for the fixed header
    let headerOffset = window.innerHeight * 0.15;
    if (window.innerWidth > 767) {
      headerOffset = 0;
    }

    const yOffset = yPosition - headerOffset;
    window.scrollTo({
      top: yOffset,
      behavior: 'smooth',
    });
  };

  return (
    <div className="w-full overflow-hidden">
      {/* 4 squares in one row, no gap */}
      <div className="grid grid-cols-4 gap-0 w-full">
        {SECTIONS.map((sec, index) => (
          <button
            key={sec.id}
            onClick={() => handleScroll(sec.id)}
            className="
              relative 
              aspect-square
              overflow-hidden
            "
          >
            {/* Top portion: image fills ~80% of the square */}
            <img
              src={SQUARE_IMAGES[index]}
              alt={sec.label}
              className="
                absolute 
                top-0 
                left-0
                w-full 
                h-[80%]
                object-cover
              "
            />
            {/* Bottom portion: label occupies ~20% of the square */}
            <div
              className={`
                absolute
                bottom-0
                w-full
                h-[20%]
                ${index % 2 !== 0 ? 'bg-sea' : 'bg-maroon'}
                flex
                items-center
                justify-center
              `}
            >
              <span
                className="
                  font-charles
                  text-white
                  text-xl
                  md:text-2xl
                  uppercase
                "
              >
                {sec.label}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickNav;
